import { PlanType } from '../../../store/funnelV3Store';

/**
 * Exit-intent prices — 60% off strikethrough originals (40% of original).
 * Join-funnel pricing test. Used when API plans are not available.
 */
export const EXIT_INTENT_PRICES: Record<PlanType, number> = {
    '1_week_trial': 6.36,
    '4_week': 11.99,
    '12_week': 31.16,
};

/** Strikethrough "before" prices shown in exit-intent banner. */
export const EXIT_INTENT_ORIGINAL_PRICES: Record<PlanType, number> = {
    '1_week_trial': 15.9,
    '4_week': 29.99,
    '12_week': 77.9,
};
